import { FREEMIUM_EVENT_STEPS } from '../../../pro/views/AlbumFolder/FreemiumEventCreateWizard/constants';

export const FREEMIUM_EVENT_SIGNUP_FLOW_VARIANTS = {
  VARIANT_A: 'VARIANT_A', // Sign in/up at the end
  VARIANT_B: 'VARIANT_B', // Sign in/up at the start
};

export const FREEMIUM_EVENT_CREATE_WALDOFIED_STEP_VARIANTS = {
  VARIANT_A: 'VARIANT_A', // Illustration
  VARIANT_B: 'VARIANT_B', // Comparison chart
};

export const FREEMIUM_EVENT_CREATE_SKU_UPSELL_STEP_VARIANTS = {
  VARIANT_A: 'VARIANT_A', // Rectangle shape + Positive Message
  VARIANT_B: 'VARIANT_B', // Rectangle shape + FOMO
  VARIANT_C: 'VARIANT_C', // Square shape +  FOMO
  VARIANT_D: 'VARIANT_D', // Square shape +  Positive Message
};

export const FREEMIUM_EVENT_SIGNUP_FLOW_VARIANT_A = [
  FREEMIUM_EVENT_STEPS.LANDING_PAGE,
  FREEMIUM_EVENT_STEPS.DETAILS,
  FREEMIUM_EVENT_STEPS.SKU_SELECTION,
  FREEMIUM_EVENT_STEPS.WALDOFICATION,
  FREEMIUM_EVENT_STEPS.SUBSCRIPTION_UPSELL,
  FREEMIUM_EVENT_STEPS.UPGRADE,
  FREEMIUM_EVENT_STEPS.UPGRADE_BUNDLE,
  FREEMIUM_EVENT_STEPS.PERMISSIONS,
  FREEMIUM_EVENT_STEPS.REVIEW,
  FREEMIUM_EVENT_STEPS.REGISTRATION,
  FREEMIUM_EVENT_STEPS.PHONE_VERIFICATION,
  FREEMIUM_EVENT_STEPS.EMAIL_PIN_VERIFICATION,
];

// VARIANT B HAS BEEN DETERMINED THE WINNER. IN CASE WE NEED TO RE-TEST WITH MORE VARIANTES
// CODE HAS BEEN LEFT HERE TO MAKE IT EASIER.
export const FREEMIUM_EVENT_SIGNUP_FLOW_VARIANT_B = [
  FREEMIUM_EVENT_STEPS.LANDING_PAGE,
  FREEMIUM_EVENT_STEPS.REGISTRATION,
  FREEMIUM_EVENT_STEPS.PHONE_VERIFICATION,
  FREEMIUM_EVENT_STEPS.EMAIL_PIN_VERIFICATION,
  FREEMIUM_EVENT_STEPS.DETAILS,
  FREEMIUM_EVENT_STEPS.SKU_SELECTION,
  FREEMIUM_EVENT_STEPS.WALDOFICATION,
  FREEMIUM_EVENT_STEPS.SUBSCRIPTION_UPSELL,
  FREEMIUM_EVENT_STEPS.UPGRADE,
  FREEMIUM_EVENT_STEPS.UPGRADE_BUNDLE,
  FREEMIUM_EVENT_STEPS.PERMISSIONS,
  FREEMIUM_EVENT_STEPS.REVIEW,
];

export const FREEMIUM_EVENT_SIGNUP_FLOW_VARIANTS_VALUES = {
  [FREEMIUM_EVENT_SIGNUP_FLOW_VARIANTS.VARIANT_A]: FREEMIUM_EVENT_SIGNUP_FLOW_VARIANT_A,
  [FREEMIUM_EVENT_SIGNUP_FLOW_VARIANTS.VARIANT_B]: FREEMIUM_EVENT_SIGNUP_FLOW_VARIANT_B,
};

export const SESSION_STATE = {
  START: 'START',
  END: 'END',
};
